interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Optimism = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_27118)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#FE0621"
      />
      <path
        d="M31.8458 65.5654C28.3645 65.5654 25.514 64.7477 23.2944 63.1122C21.0981 61.4533 20 59.0701 20 56.0093C20 55.3551 20.0701 54.5841 20.2103 53.6495C20.5841 51.5467 21.1215 49.0234 21.8224 46.0561C23.8084 38.0187 28.9486 34 37.2196 34C39.4626 34 41.4953 34.3738 43.271 35.1449C45.0467 35.8692 46.4486 36.9907 47.4766 38.486C48.5047 39.9579 49.0187 41.7103 49.0187 43.743C49.0187 44.3505 48.9486 45.1215 48.8084 46.0561C48.3645 48.6495 47.8505 51.1963 47.2196 53.6495C46.1916 57.6449 44.4393 60.6589 41.9159 62.6449C39.4159 64.6075 36.0514 65.5654 31.8458 65.5654ZM32.4766 59.257C34.1122 59.257 35.4907 58.7664 36.6355 57.8084C37.8037 56.8505 38.6449 55.3785 39.1355 53.3692C39.8131 50.6122 40.3271 48.229 40.6776 46.1729C40.7944 45.5654 40.8645 44.9346 40.8645 44.2804C40.8645 41.6168 39.486 40.285 36.7056 40.285C35.0701 40.285 33.6682 40.7757 32.5 41.7336C31.3551 42.6916 30.5374 44.1636 30.0467 46.1729C29.5093 48.1355 28.9953 50.5187 28.4579 53.3692C28.3411 53.9533 28.271 54.5607 28.271 55.215C28.2477 57.9252 29.6729 59.257 32.4766 59.257Z"
        fill="white"
      />
      <path
        d="M51.0514 65.1449C50.7243 65.1449 50.4907 65.0514 50.3037 64.8411C50.1636 64.6075 50.1168 64.3505 50.1636 64.0467L56.215 35.5421C56.2617 35.215 56.4252 34.9579 56.7056 34.7477C56.9626 34.5374 57.243 34.4439 57.5467 34.4439H69.2056C72.4533 34.4439 75.0467 35.1215 77.0093 36.4533C78.9953 37.8084 80 39.7477 80 42.2944C80 43.0187 79.9065 43.7897 79.743 44.5841C79.0187 47.9486 77.5467 50.4252 75.3037 52.0374C73.1075 53.6495 70.0935 54.4439 66.2617 54.4439H60.3505L58.3411 64.0467C58.271 64.3738 58.1308 64.6308 57.8505 64.8411C57.5935 65.0514 57.3131 65.1449 57.0093 65.1449H51.0514ZM66.5654 48.3925C67.8037 48.3925 68.8551 48.0654 69.7664 47.3879C70.7009 46.7103 71.3084 45.7523 71.6122 44.4907C71.7056 44 71.7523 43.5561 71.7523 43.1822C71.7523 42.3411 71.4953 41.6869 71.0047 41.243C70.514 40.7757 69.6495 40.5421 68.4579 40.5421H63.2009L61.5421 48.3925H66.5654Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_27118">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
